// 포트 → 구현 주입. 화면은 이 훅만 알고 adapters/ 는 모른다 (ADR-048 D1)
import { createContext, use, type ReactNode } from 'react';

import type { HealthSource } from '../ports/health-source';

export interface Ports {
  readonly health: HealthSource;
}

const PortsContext = createContext<Ports | null>(null);

export function PortsProvider({ ports, children }: { ports: Ports; children: ReactNode }) {
  return <PortsContext value={ports}>{children}</PortsContext>;
}

export function usePorts(): Ports {
  const ports = use(PortsContext);
  if (!ports) throw new Error('PortsProvider 밖에서 usePorts 호출');
  return ports;
}
